import { useMemo } from 'react';
import { useDesignerStore } from '../store';
import {
  MOCK_ACCOUNTS,
  MOCK_COMPANIES,
  MOCK_PERIODS,
  MOCK_CONNECTIONS,
  MOCK_DATE_FISCAL,
} from '../mock-data';
import { compileReport } from '@calculom/report-designer';
import type { DataContext } from '@calculom/report-designer';
import { WebReportTable } from './WebReportTable';
import { ReportParameterHeader } from './ReportParameterHeader';

// ============================================================
// Build a DataContext from mock data
// ============================================================

const MOCK_DATA_CONTEXT: DataContext = {
  companies: MOCK_COMPANIES,
  periods: MOCK_PERIODS,
  accounts: MOCK_ACCOUNTS,
  erpConnections: MOCK_CONNECTIONS,
  dateFiscalInfo: MOCK_DATE_FISCAL,
};

// ============================================================
// ReportViewer component
// ============================================================

export function ReportViewer() {
  const { definition, nodes, columnConfig } = useDesignerStore();
  const { theme } = definition;

  const renderRows = useMemo(() => {
    if (nodes.length === 0) return [];
    return compileReport(nodes, columnConfig, theme, MOCK_DATA_CONTEXT);
  }, [nodes, columnConfig, theme]);

  const selectedCompany = MOCK_COMPANIES[0]?.name ?? '';
  const selectedPeriod = MOCK_PERIODS[0]?.name ?? '';

  return (
    <div className="p-2">
      <ReportParameterHeader
        reportName={definition.name}
        dataContext={MOCK_DATA_CONTEXT}
        selectedCompany={selectedCompany}
        selectedPeriod={selectedPeriod}
      />
      {renderRows.length === 0 ? (
        <div className="p-4 text-sm text-gray-400 italic">
          Add rows to the canvas to see a preview
        </div>
      ) : (
        <WebReportTable rows={renderRows} />
      )}
    </div>
  );
}
